import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-processing-document-dialog",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule, TranslateModule],
  templateUrl: "./processing-document-dialog.component.html",
  styleUrls: ["./processing-document-dialog.component.scss"],
})
export class ProcessingDocumentDialogComponent {}
